export class AssetGroupInfo {
  AssetGroupID: number
  AssetPortfolioCode: string
  AssetPortfolioName: string
  AssetGroupCode: string
  AssetGroupName: string
  AssetGroupDesc: string
  AssetGroupCreateDate: string
  AssetGroupCreateBy: string
  AssetGroupCreateByName: string
  AssetGroupUpdateDate: string
  AssetGroupUpdateBy: string
  AssetGroupUpdateName: string
  AssetGroupFlagDelete: string
  AssetCategoryCode: string
  AssetCategoryName: string
  AssetCategoryDesc: string
  AssetTypeCode: string
  AssetTypeName: string
  AssetTypeDesc:string
  rowFetch: number
  rowOFFSet: number
  itemTotal: number
}
